import { useModal } from '@/context/ModalContext'
import React from 'react'

const Modal = () => {
  const { modal, hide } = useModal()

  if (!modal.open) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='bg-white w-64 p-5 rounded-2xl shadow-xl text-center animate-fadeIn'>
        <h2 className='text-md font-semibold text-gray-800 mb-3'>{modal.title}</h2>

        <button onClick={hide} className='mt-2 bg-[#AC5E2A] text-white px-4 py-2 rounded-xl w-full active:scale-95 transition'>
          Tamam
        </button>
      </div>
    </div>
  )
}

export default Modal
